// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J8lG","colBig":"styles_colBig__2uK8S","colSmall":"styles_colSmall__EgQGR","shopifyNameWrapper":"styles_shopifyNameWrapper__3EK2C"};